<template>
  <WsMain>
    <WsCRUD
      v-if="isMounted"
      ref="WsCRUD"
      pageMode
      liveSearching
      rowClickRead
      inRowBtnDelete
      :label="label"
      :fields="fields"
      :showExpand="false"
      :isCreatable="false"
      :modelName="modelName"
      :inRowBtnUpdate="false"
      :showFields="showFields"
      :filterProps="filterProps"
      :filterSelects="filterSelects"
      :wrapColumns="wrapColumns"
      @filter-select="$_onFilterSelect($event)"
      @set-modelDatas="$_onSetModelDatas"
    >
      <template v-slot:customBtns="{ item }">
        <WsIconBtn
          v-if="_isShowInRowBtnUpdate"
          tooltip="編輯"
          tooltipPosition="top"
          class="ml-1 mr-1"
          @click.stop="$_onOpenIdtfSettingPopup(item)"
        >mdi-pencil</WsIconBtn>
      </template>
    </WsCRUD>
    <WsUpdateDialog
      ref="idtfSettingPopup"
      customTitle
      label="鑑別人員設定"
      :fields="idtfSettingFields"
      :isLoading="isLoading.idtfSettingPopup"
      @update-submit="$_onSubmitIdtfSettingPopup"
    />
  </WsMain>
</template>

<script>
import model from '@/models/act_idtf_assignment';
import S_idtf from '@/services/api/v1/idtf';

export default {
  data() {
    return {
      isMounted: false,
      modelName: model.modelName,
      label: model.label,
      fields: model.fields,
      filterSelects: [
        {
          type: 'select',
          label: '',
          modelName: 'act_cnt_status',
          placeholder: '篩選內容格式狀態',
          textKey: 'name',
          items: [
            {
              text: '全部',
              value: '',
            },
            {
              text: '更新中',
              value: '1',
            },
            {
              text: '覆核中',
              value: '2',
            },
            {
              text: '完成',
              value: '3',
            },
          ],
          defaultValue: '',
        },
        {
          type: 'select',
          label: '',
          modelName: 'idtf_status',
          placeholder: '篩選法規鑑別狀態',
          textKey: 'name',
          items: [
            {
              text: '全部',
              value: '',
            },
            {
              text: '鑑別中',
              value: '1',
            },
            {
              text: '覆核中',
              value: '2',
            },
            {
              text: '完成',
              value: '3',
            },
          ],
          defaultValue: '',
        },
        {
          requiredField: 'is_release',
          requiredFieldValue: '2',
          label: '',
          type: 'date',
          textKey: 'name',
          modelName: 'start_time',
          placeholder: '篩選發布起訖日期',
          hasNoSearch: true,
          hasAllSelectBtn: true,
        },
        {
          requiredField: 'is_release',
          requiredFieldValue: '2',
          label: '',
          type: 'date',
          textKey: 'name',
          modelName: 'end_time',
          placeholder: '篩選發布完畢日期',
          hasNoSearch: true,
          hasAllSelectBtn: true,
        },
        {
          type: 'switch-tabs',
          label: '',
          textKey: 'name',
          modelName: 'is_release',
          defaultValue: '1',
          items: [
            {
              value: '1',
              text: '尚未發布',
            },
            {
              value: '2',
              text: '發布',
            },
          ],
        },
      ],
      filterProps: {},
      showFields: [
        'act_version',
        'act_cnt_status',
        'idtf_status',
        'overall_review_status',
        'updated_admin',
        'updated_at',
        'created_admin',
        'created_at',
      ],
      idtfSettingFields: {},
      isLoading: {
        idtfSettingPopup: false,
      },
      wrapColumns: ['act_version'],
    };
  },
  computed: {
    _isShowInRowBtnUpdate() {
      return this.filterProps.is_release !== '2';
    },
  },
  mounted() {
    this.isMounted = true;
  },
  methods: {
    $_onFilterSelect($event) {
      this.filterProps = {
        ...$event,
      };
    },
    async $_onOpenIdtfSettingPopup(item) {
      const ref = this.$refs.idtfSettingPopup;
      const idtfId = item.id;
      ref.open();
      this.isLoading.idtfSettingPopup = true;
      this.idtfSettingFields = this.$_setIdtfSettingFields(item);
      const res = await S_idtf.show(idtfId);
      this.isLoading.idtfSettingPopup = false;
      ref.open(res);
    },
    $_setIdtfSettingFields(item) {
      const {
        km_owners,
        km_backups,
        km_reviewers,
        idtf_owners,
        idtf_backups,
        idtf_reviewers,
        overall_owners,
      } = model.fields;
      const baseFields = {
        km_owners,
        km_backups,
        km_reviewers,
      };
      if (!item || item.has_idtf !== '是') return baseFields;
      return {
        ...baseFields,
        idtf_owners,
        idtf_backups,
        idtf_reviewers,
        overall_owners,
      };
    },
    async $_onSubmitIdtfSettingPopup($event) {
      const ref = this.$refs.idtfSettingPopup;
      try {
        ref.startLoading();
        const idtfId = $event.id;
        await S_idtf.update(idtfId, $event);
        ref.stopLoading();
        ref.close();
        await this.$refs.WsCRUD.$_fetchData();
      } catch (error) {
        ref.stopLoading();
        alert(error);
      }
    },
    $_onSetModelDatas(dataList) {
      dataList.forEach(item => {
        item.isInRowBtnDeleteDisabled = item.act_cnt_status === 3;
      });
    }
  },
};
</script>